import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "doctor-card elevation-1 rounded-sm" },
    [
      _c("div", { staticClass: "pt-4" }, [
        _c(
          "a",
          { attrs: { href: `/memorial/${_vm.doctor.id}/` } },
          [
            _c(VImg, {
              staticClass: "doctor-card__img mx-auto",
              attrs: {
                contain: "",
                width: "150",
                height: "150",
                src: _vm.doctor.avatar_url,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(VDivider),
      _vm._v(" "),
      _c("div", { staticClass: "pa-4 text-center" }, [
        _c(
          "a",
          {
            staticClass:
              "link-decoration-none text-subtitle-1 primary--text mb-1",
            attrs: { href: `/memorial/${_vm.doctor.id}/` },
          },
          [_vm._v("\n      " + _vm._s(_vm.doctor.fio) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 text-info--text mb-1" }, [
          _vm._v("\n      " + _vm._s(_vm.doctor.town.name) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2" }, [
          _vm._v("\n      " + _vm._s(_vm.doctor.spec.name) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-body-2" },
          [
            _vm.doctor.gender === "F"
              ? [_vm._v("\n        Помогала людям\n      ")]
              : [_vm._v("\n        Помогал людям\n      ")],
            _vm._v(" "),
            _vm.doctor.experience_year && _vm.doctor.experience_end_year
              ? [
                  _vm._v(
                    "\n        с " +
                      _vm._s(_vm.doctor.experience_year) +
                      " по " +
                      _vm._s(_vm.doctor.experience_end_year) +
                      "\n      "
                  ),
                ]
              : _vm.doctor.experience_year
              ? [
                  _vm._v(
                    "\n        c " +
                      _vm._s(_vm.doctor.experience_year) +
                      " года\n      "
                  ),
                ]
              : _vm.doctor.experience_end_year
              ? [
                  _vm._v(
                    "\n        до " +
                      _vm._s(_vm.doctor.experience_end_year) +
                      " года\n      "
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }